import { render, staticRenderFns } from "./NeoTitle.vue?vue&type=template&id=1c915f76&scoped=true&"
import script from "./NeoTitle.vue?vue&type=script&lang=js&"
export * from "./NeoTitle.vue?vue&type=script&lang=js&"
import style0 from "./NeoTitle.vue?vue&type=style&index=0&id=1c915f76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c915f76",
  null
  
)

export default component.exports